// extracted by mini-css-extract-plugin
export default {"redaction":"ByckyfVu","mobile":"mobile","editor":"RM45PBsI","content":"x5pW2D6K","jobTitle":"hzfyZcBY","email":"XILxgb9q"};